import React, { Component } from 'react';
import { Table, Row, Button, Modal, message, Input, Spin, Col, Divider, Tree, Select, Popconfirm } from 'antd';
import './index.scss';
import authDataEs from "./data";
import authDataBp from "../../bp-views/user/data";
import authDataHr from "../../hr/user/data";
import request from "@/method/request"

const authData = {
    1: authDataEs,
    2: authDataBp,
    3: authDataHr
};

const TreeNode = Tree.TreeNode;
const Option = Select.Option;

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pwdvisible: false,
            data: [],
            visible: false,
            loadingSave: false,
            loading: true,
            dataTotal: [],
            selectedRowKeys: [],
            hotel: [],
            hotelTotal: [],
            pwdData: {
                id: "",
                password: "",
                comfirm: ""
            },
            dataSubmit: {
                name: "",
                account: "",
                password: "",
                hotels: '',
                comid: 888
            },
            authData: [],
            authVisible: false,
            expandedKeys: [],
            autoExpandParent: true,
            checkedKeys: [],
            selectedKeys: [],
            auth: {},
            authLoading: false,
            hotelAuthName: '1',
            info: sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : {},
            dataTotal: [],
            record: {}
        }
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        fetch('/getHeadquarters', { credentials: 'include' }).then(x => x.json()).then(x => {
            this.setState({ loading: false });
            if (x.status == 1) {
                this.setState({
                    data: x.data.data || [],
                    dataTotal: x.data.data || [],
                    hotel: x.data.hotels || [],
                    hotelTotal: x.data.hotels || []
                });
                return
            }
            message.error('数据获取失败！' + JSON.stringify(x.msg))
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
            message.error('数据获取失败！' + JSON.stringify(err))
        })
    }

    showModal = () => {
        this.setState({
            visible: true, dataSubmit: {
                name: "",
                account: "",
                password: "",
                hotels: '',
                comid: 888
            }
        });
    }

    handleHotelsOk = () => {
        this.setState({ loadingSave: true });
        let data = { ...this.state.dataSubmit };
        if (!data.name || !data.account) {
            message.error('信息不能为空！');
            this.setState({ loadingSave: false });
            return
        }
        data.account = data.account + '_admin';
        const selectedRowKeys = this.state.selectedRowKeys;
        if (selectedRowKeys.length <= 0) {
            message.error('请至少选择一家酒店！');
            this.setState({ loadingSave: false });
            return
        }

        data.hotels = selectedRowKeys.toString();

        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: JSON.stringify(data)
        }

        let url = data.id ? '/editHeadquarters' : '/addHeadquarters';
        fetch(url, headres).then(x => x.json()).then(x => {
            this.setState({ loadingSave: false });
            if (x.status == 1) {
                message.info('添加成功！');
                this.setState({
                    visible: false, dataSubmit: {
                        name: "",
                        account: "",
                        password: "",
                        hotels: '',
                        comid: 888
                    }
                });
                this.getData();
                return
            }
            message.error('添加失败！');
        }).catch(err => {
            message.error('添加失败！');
            this.setState({ loadingSave: false });
            console.error(err);
        })

    }

    renderTreeNodes = (data) => {
        return data.map((item) => {
            if (item.children) {
                return (
                    <TreeNode title={item.title} key={item.key} dataRef={item}>
                        {this.renderTreeNodes(item.children)}
                    </TreeNode>
                );
            }
            return <TreeNode {...item} />;
        });
    }

    handleCancel = () => {
        this.setState({
            pwdvisible: false,
            pwdData: {
                password: "",
                comfirm: "",
                id: ""
            }
        });
    }

    handleOk = () => {
        let data = this.state.pwdData;
        this.setState({ loadingSave: true });
        if (!data.password || !data.confirm || data.password != data.confirm) {
            message.error('输入错误，请检查密码！');
            this.setState({ loadingSave: false });
            return
        }

        let dataFrom = new FormData();
        delete data.confirm;

        data = {
            id: data.id,
            password: data.password
        };
        // console.log(data);
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                dataFrom.append(key, data[key]);
            }
        }

        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/addUser', headres).then(x => x.json()).then(x => {
            this.setState({
                loadingSave: false,
                pwdvisible: false
            });
            if (x.status == 1) {
                message.info('修改成功!');

                return
            }


        }).catch(err => {
            console.error(err);
            message.error('数据添加失败！')
            this.setState({
                loadingSave: false,
                pwdvisible: false
            });
        })
    }


    getAuthData = (record) => {

        fetch(`/getAllAuth?name=${record.account}&type=${this.state.hotelAuthName}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.data) {
                let checkedKeys = x.data.data.split(',');
                this.setState({
                    auth: x,
                    checkedKeys,
                    authLoading: false
                });
            } else {
                this.setState({
                    auth: { data: "" },
                    checkedKeys: [],
                    authLoading: false
                });
            }

        }).catch(err => {
            console.error(err);
            this.setState({
                authLoading: false
            });
        })
    }

    // 权限
    authshowModal = (record) => {
        if (this.state.info.email != 'admin') {
            message.error('权限不足！')
            return
        }
        this.setState({
            authVisible: true,
            authLoading: true,
            record
        });
        this.getAuthData(record);

    }
    authhandleOk = (e) => {
        if (this.state.info.email != 'admin') {
            message.error('权限不足！')
            return
        }
        this.setState({ loadingAuth: true });
        let checkedKeys = this.state.checkedKeys;
        let hotelAuthName = this.state.hotelAuthName;
        const record = this.state.record;

        let data = {
            ...this.state.auth,
            user: record.account,
            data: checkedKeys.toString(),
            type: hotelAuthName
        }

        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/saveAllAuth', headres).then(x => x.json()).then(x => {
            this.setState({ loadingAuth: false });
            if (x.status == 1) {
                message.success('保存成功');
                return
            }

            message.error('保存失败！')
        }).catch(err => {
            console.error(err);
            this.setState({ loadingAuth: false });
        })

    }
    authhandleCancel = (e) => {
        this.setState({
            authVisible: false,
        });
    }

    onChange = (value, lable, extra) => {
        this.setState({
            selectAuth: value
        });
    }

    onExpand = (expandedKeys) => {
        // if not set autoExpandParent to false, if children expanded, parent can not collapse.
        // or, you can remove all expanded children keys.
        this.setState({
            expandedKeys,
            autoExpandParent: false,
        });
    }
    onCheck = (checkedKeys, checkedNodes) => {
        this.setState({ checkedKeys });
    }
    onSelect = (selectedKeys, info) => {
        this.setState({ selectedKeys });
    }

    onDel = async id => {
        const res = await request(`/headquarters/del?id=${id}`);
        if (res.status == 1) this.setState({ data: this.state.data.filter(x => x.id != id) });
    }

    render() {
        const columns = [{
            title: '名称',
            dataIndex: 'name',
            key: 'name',
        }, {
            title: '帐号',
            dataIndex: 'account',
            key: 'account',
        }, {
            title: '创建时间',
            dataIndex: 'add_time',
            key: 'add_time',
        }, {
            title: '操作',
            key: 'action',
            render: (record) => {
                return (
                    <div>
                        <span
                            style={{ color: "#1890ff", cursor: "pointer" }}
                            onClick={() => {
                                let dataSubmit = { ...record };
                                let selectedRowKeys = record.hotels.split(',').map(x => Number(x));

                                this.setState({
                                    dataSubmit,
                                    visible: true,
                                    selectedRowKeys
                                });
                            }}
                        >编辑酒店权限</span>
                        <Divider type="vertical" />
                        <span
                            style={{ color: "#1890ff", cursor: "pointer" }}
                            onClick={() => {
                                this.authshowModal(record)
                            }}
                        >编辑菜单权限</span>
                        <Divider type="vertical" />
                        <span
                            style={{ color: "#1890ff", cursor: "pointer" }}
                            onClick={() => {
                                this.setState({
                                    pwdvisible: true,
                                    pwdData: {
                                        ...this.state.pwdData,
                                        id: record.user_id
                                    }
                                })
                            }}
                        >修改密码</span>
                        <Divider type="vertical" />
                        <Popconfirm
                            title="确定要删除吗，一旦删除将无法恢复?"
                            onConfirm={() => this.onDel(record.id)}
                            okText="确定"
                            cancelText="取消"
                        >
                            <span
                                style={{ color: "#F5222D", cursor: "pointer" }}

                            >删除</span>
                        </Popconfirm>

                    </div>
                )
            }
        }];
        const data = this.state.data;

        // 酒店列表
        const columnsHotel = [{
            title: '酒店名称',
            dataIndex: 'name',
            key: 'name',
        }, {
            title: '联系人',
            dataIndex: 'contacts',
            key: 'contacts',
        }, {
            title: '地址',
            dataIndex: 'address',
            key: 'address',
        }, {
            title: '联系电话',
            key: 'tel',
            dataIndex: 'tel',
        }];

        const rowSelection = {
            selectedRowKeys: this.state.selectedRowKeys,
            onChange: (key, selectedRows) => {
                this.setState({ selectedRowKeys: key });
            },
        };
        return (

            <div className='settings'>
                <Row style={{ margin: '20px 0' }}>
                    <Col span={12}>
                        <span>名称：</span>
                        <Input
                            style={{ width: 200, marginRight: 10 }}
                            value={this.state.hotelName}
                            onChange={(e) => {
                                this.setState({
                                    hotelName: e.target.value || ""
                                });
                            }}
                        />
                        <Button
                            type="primary"
                            onClick={() => {
                                let dataTotal = this.state.dataTotal;
                                let hotelName = this.state.hotelName.trim();
                                let data = dataTotal.filter(x => x.name.includes(hotelName));
                                this.setState({
                                    data
                                });

                            }}
                        >搜索</Button>
                    </Col>
                    <Col span={12}>
                        <Row type="flex" justify="end">
                            <Button
                                type="primary"
                                onClick={this.showModal}
                            >添加人员</Button>
                        </Row>
                    </Col>
                </Row>

                <Spin spinning={this.state.loading}>
                    <Table
                        style={{ marginTop: 20 }}
                        columns={columns}
                        dataSource={data}
                        bordered
                        rowKey={(item, index) => index}
                    />
                </Spin>
                <Row style={{ textAlign: "right", marginTop: 20 }}>
                    <Button
                        key="submit"
                        type="primary"
                        onClick={() => {
                            this.props.history.goBack();
                        }}
                    >
                        返回
                    </Button>
                </Row>

                <Modal
                    title={this.state.dataSubmit.id ? '人员编辑' : '人员添加'}
                    visible={this.state.visible}
                    onOk={this.handleHotelsOk}
                    onCancel={() => this.setState({ visible: false })}
                    className="compared-modal"
                    footer={[
                        <Button key="back" onClick={() => this.setState({ visible: false })}>取消</Button>,
                        <Button key="submit" type="primary" loading={this.state.loadingSave} onClick={this.handleHotelsOk}>
                            保存
                        </Button>,
                    ]}
                >
                    <Row>
                        <Col span={8}>
                            <Col span={4} style={{ paddingTop: 5 }}><span>名称：</span></Col>
                            <Col span={20}>
                                <Input
                                    onChange={(e) => {
                                        let value = (e.target.value || "").trim();
                                        let dataSubmit = this.state.dataSubmit;
                                        dataSubmit.name = value;
                                        this.setState({ dataSubmit });
                                    }}
                                    value={this.state.dataSubmit.name}
                                    disabled={this.state.dataSubmit.id || false}
                                />
                            </Col>
                        </Col>
                        <Col span={8}>
                            <Col span={6} style={{ paddingTop: 5, paddingLeft: 20 }}><span>帐号：</span></Col>
                            <Col span={18}>
                                <Input
                                    onChange={(e) => {
                                        let value = (e.target.value || "").trim();
                                        let dataSubmit = this.state.dataSubmit;
                                        dataSubmit.account = value;
                                        this.setState({ dataSubmit });
                                    }}
                                    value={this.state.dataSubmit.account}
                                    disabled={this.state.dataSubmit.id}
                                    addonAfter="_admin"
                                />

                            </Col>
                        </Col>
                        <Col span={8} style={{ display: this.state.dataSubmit.id ? 'none' : "" }}>
                            <Col span={6} style={{ paddingTop: 5, paddingLeft: 20 }}><span>密码：</span></Col>
                            <Col span={18}>
                                <Input
                                    type="password"
                                    onChange={(e) => {
                                        let value = (e.target.value || "").trim();
                                        let dataSubmit = this.state.dataSubmit;
                                        dataSubmit.password = value;
                                        this.setState({ dataSubmit });
                                    }}
                                    value={this.state.dataSubmit.password}
                                />
                            </Col>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 20 }}>
                        <span>酒店名称：</span>
                        <Input
                            style={{ width: 200, marginRight: 10 }}
                            value={this.state.name}
                            onChange={(e) => {
                                this.setState({
                                    name: (e.target.value || "").trim()
                                });
                            }}
                        />
                        <Button
                            type="primary"
                            onClick={() => {
                                let hotelTotal = this.state.hotelTotal;
                                let name = this.state.name;
                                let hotel = hotelTotal.filter(x => x.name.includes(name));
                                this.setState({
                                    hotel
                                });

                            }}
                        >搜索</Button>
                    </Row>
                    <Row style={{ marginTop: 20 }}>
                        已选酒店{this.state.selectedRowKeys.length || "0"}家
                    </Row>
                    <Table
                        style={{ marginTop: 10 }}
                        columns={columnsHotel}
                        dataSource={this.state.hotel}
                        bordered
                        className="hotelModal"
                        rowSelection={rowSelection}
                        rowKey={item => item.id}
                    />

                </Modal>

                {/* 酒店人员权限 */}
                <Modal
                    title='权限设置'
                    visible={this.state.authVisible}
                    onOk={this.authhandleOk}
                    onCancel={this.authhandleCancel}
                    footer={[
                        <Button key="back" onClick={this.authhandleCancel}>取消</Button>,
                        <Button key="submit" type="primary" loading={this.state.loadingAuth} onClick={this.authhandleOk}>
                            保存
                        </Button>,
                    ]}
                >
                    <Spin spinning={this.state.authLoading}>
                        <Row className="modal">
                            <Row>
                                <span>选择人员：</span>
                                <Select
                                    value={this.state.hotelAuthName}
                                    style={{ width: 300 }}
                                    onChange={(value) => {
                                        this.setState({
                                            hotelAuthName: value,
                                            authLoading: true,
                                            checkedKeys: []
                                        }, () => {
                                            this.getAuthData(this.state.record)
                                        });
                                    }}
                                >

                                    <Option key="1">Executive Summary Report 月度经营报告</Option>
                                    <Option key="2">Business Plan 年度经营计划</Option>
                                    <Option key="3">Human Resources 人力资源报告</Option>
                                </Select>
                            </Row>
                            <Row className="authCotent">
                                <Row>权限配置</Row>
                                <Tree
                                    checkable
                                    onExpand={this.onExpand}
                                    expandedKeys={this.state.expandedKeys}
                                    autoExpandParent={this.state.autoExpandParent}
                                    onCheck={this.onCheck}
                                    checkedKeys={this.state.checkedKeys}
                                    onSelect={this.onSelect}
                                    selectedKeys={this.state.selectedKeys}
                                >
                                    {this.renderTreeNodes(authData[this.state.hotelAuthName])}
                                </Tree>
                            </Row>
                        </Row>
                    </Spin>
                </Modal>

                <Modal
                    title='修改密码'
                    visible={this.state.pwdvisible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" onClick={this.handleCancel}>取消</Button>,
                        <Button key="submit" type="primary" loading={this.state.loadingSave} onClick={this.handleOk}>
                            保存
                        </Button>,
                    ]}
                >
                    <Row className="settings-modal-content" >
                        <span>密码：</span>
                        <Input
                            placeholder="请输入密码"
                            style={{ width: '60%', marginLeft: 38 }}
                            value={this.state.pwdData.password}
                            type='password'
                            name="ppp"
                            onChange={(e) => {
                                let value = e.target.value;
                                let data = this.state.pwdData;
                                data.password = value;
                                this.setState({
                                    pwdData: data
                                });
                            }}
                        />
                    </Row>
                    <Row className="settings-modal-content" >
                        <span>确认：</span>
                        <Input
                            placeholder="请输入密码"
                            style={{ width: '60%', marginLeft: 38 }}
                            value={this.state.pwdData.confirm}
                            type='password'
                            name="ppp"
                            onChange={(e) => {
                                let value = e.target.value;
                                let data = this.state.pwdData;
                                data.confirm = value;
                                this.setState({
                                    pwdData: data
                                });
                            }}
                        />
                    </Row>
                    <Row className="settings-modal-content" style={{ color: "red", paddingLeft: 80 }}>
                        {this.state.pwdData.password && this.state.pwdData.confirm && this.state.pwdData.password != this.state.pwdData.confirm ? '两次输入的密码不一致！' : ""}
                    </Row>
                </Modal>
            </div>

        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/setting/Headquarters.js